import React from 'react';
import styled, { css } from 'styled-components';

import { convertThumbnailToPictureProps } from '@tager/web-modules';

import Picture from '@/components/Picture';

import { CarComplectationProps } from './types';

export function CarComplectation({
  image,
  name,
  isActive = true,
  onClick,
}: CarComplectationProps) {
  return (
    <Component onClick={onClick}>
      <Image
        loading="lazy"
        {...convertThumbnailToPictureProps(image)}
        isActive={isActive}
        alt={name}
      />
      <Info>{name}</Info>
    </Component>
  );
}

const Component = styled.div`
  cursor: pointer;
`;

const Image = styled(Picture)<{ isActive: boolean }>`
  padding-top: 57.145%;

  img,
  picture {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  img {
    object-fit: cover;
  }

  ${({ isActive }) =>
    !isActive &&
    css`
      opacity: 0.7;
    `};
`;

const Info = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-top: 20px;
  color: ${(props) => props.theme.black};
`;
